namespace $.$$ {
	
	$mol_style_define( $hyoo_budget_category_page, {
		
		flex: {
			basis: `35rem`,
		},
		
		Tools: {
			flex: {
				grow: 0,
			},
		},

		Title: {
			flex: {
				basis: `10rem`,
			},
		},

	} )
	
}
